export const ENV = import.meta.env.VITE_ENV
export const IS_DEV = ENV === 'development'
export const IS_PROD = ENV === 'production'
export const IS_PRELIVE = ENV === 'prelive'
export const IS_STAGING = ENV === 'staging'
export const IS_TESTNET = IS_DEV || IS_STAGING
export const APP_URL = import.meta.env.VITE_APP_URL
export const APP_NAME = import.meta.env.VITE_APP_NAME
export const FLOW_VERSION = parseInt(import.meta.env.VITE_FLOW_VERSION)

export const TRADE_TIMEOUT = parseInt(import.meta.env.VITE_TRADE_TIMEOUT)
export const BRIDGE_MAX_RETRY_TIMEOUT = parseInt(import.meta.env.VITE_BRIDGE_MAX_RETRY_TIMEOUT)
export const SCRIPT_TIMEOUT = parseInt(import.meta.env.VITE_SCRIPT_TIMEOUT)

export const IS_DISABLE_FIXED_SWAP = import.meta.env.VITE_DISABLE_FIXED_RATE === '1'
export const IS_DISABLE_TURBO_SWAP = import.meta.env.VITE_DISABLE_TURBO_SWAP === '1'
export const IS_ENABLE_TELEGRAM_NOTIFY = import.meta.env.VITE_ENABLE_TELEGRAM_BOT_NOTIFY !== '0'

export const IS_MAINNET = IS_PROD || IS_PRELIVE
// todo sdk
export enum SUPPORTED_NETWORK {
  OPTIMEX = 'optimex',
  BTC = 'bitcoin',
  BTC_TESTNET = 'bitcoin_testnet',
  BASE_SEPOLIA = 'base_sepolia',
  BASE = 'base',
  ETHEREUM = 'ethereum',
  ETHEREUM_SEPOLIA = 'ethereum_sepolia',
  ARBITRUM = 'arbitrum',
  ARBITRUM_SEPOLIA = 'arbitrum_sepolia',
  OPTIMISM = 'optimism',
  OPTIMISM_SEPOLIA = 'optimism_sepolia',
  BSC = 'bsc',
  SOLANA = 'solana',
  SOLANA_DEVNET = 'solana_devnet',
}
export const ACROSS_SUPPORTED_NETWORKS = [
  SUPPORTED_NETWORK.ARBITRUM,
  SUPPORTED_NETWORK.ARBITRUM_SEPOLIA,
  SUPPORTED_NETWORK.OPTIMISM,
  SUPPORTED_NETWORK.OPTIMISM_SEPOLIA,
  SUPPORTED_NETWORK.BASE,
  SUPPORTED_NETWORK.BASE_SEPOLIA,
  SUPPORTED_NETWORK.BSC,
]
const IS_ALLOW_FIXED_RATE_ACROSS_DEPOSIT = !!new URLSearchParams(window.location.search).get('fixedRateAcrossDeposit')
export const FIXED_RATE_IGNORE_NETWORKS = IS_ALLOW_FIXED_RATE_ACROSS_DEPOSIT ? [] : ACROSS_SUPPORTED_NETWORKS
export const EVM_NETWORK_KEY = IS_PROD || IS_PRELIVE ? SUPPORTED_NETWORK.ETHEREUM : SUPPORTED_NETWORK.ETHEREUM_SEPOLIA

//key wallet
export const WALLET_BITGET = 'bitget'
export const WALLET_BINANCE = 'binance'
export const WALLET_COINBASE = 'coinbase'
export const WALLET_METAMASK = 'metamask'
export const WALLET_WAGMI = 'wagmi'
export const WALLET_SOLANA = 'solana'
export const WALLET_OKX = 'okx'
export const WALLET_PHANTOM = 'phantom'
export const WALLET_LEDGER = 'ledger'
export const WALLET_TREZOR = 'trezor'
export const WALLET_TRUST = 'trust'
export const WALLET_RABBY = 'rabby'
export const WALLET_UNISAT = 'unisat'
export const WALLET_XVERSE = 'xverse'
export const WALLET_CONNECT = 'wallet_connect'
export const WALLET_IM_TOKEN = 'im_token'

export const WALLET_ICONS: Record<string, string> = {
  [WALLET_BITGET]: '/wallet/bitget.svg',
  [WALLET_COINBASE]: '/wallet/coinbase.svg',
  [WALLET_METAMASK]: '/wallet/metamask.svg',
  [WALLET_RABBY]: '/wallet/rabby.svg',
  [WALLET_BINANCE]: '/wallet/binance.jpeg',
  [WALLET_OKX]: '/wallet/okx.svg',
  [WALLET_PHANTOM]: '/wallet/phantom.svg',
  [WALLET_TREZOR]: '/wallet/trezor.svg',
  [WALLET_TRUST]: '/wallet/trust.svg',
  [WALLET_UNISAT]: '/wallet/unisat.svg',
  [WALLET_XVERSE]: '/wallet/xverse.svg',
  [WALLET_CONNECT]: '/wallet/wallet-connect.svg',
  [WALLET_LEDGER]: '/wallet/ledger.svg',
  [WALLET_IM_TOKEN]: '/wallet/im-token.svg',
}
Object.keys(WALLET_ICONS).forEach((key) => {
  WALLET_ICONS[key.toUpperCase()] = WALLET_ICONS[key]
})

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT
export const OPTIMEX_RPC_URL = import.meta.env.VITE_API_OPTIMEX_RPC_URL
export const OPTIMEX_RPC_API_KEY = import.meta.env.VITE_API_KEY_OPTIMEX_RPC
export const WALLET_CONNECT_PROJECT_ID = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID
export const MOCK_EVM_WALLET = import.meta.env.VITE_MOCK_EVM_WALLET

//treroz
export const TREZOR_EMAIL = import.meta.env.VITE_TREZOR_EMAIL

export enum WalletType {
  WALLET_TYPE_BROWSER_WALLET = 'Browser Wallets',
  WALLET_TYPE_HARDWARE_WALLET = 'Hardware Wallets',
}

export const BTC_REFUND_SIZE = 200
export const BTC_BLOCK_EXPIRE = 144

export const API_ENDPOINTS = {
  mempool: {
    mainnet: 'https://mempool.space/api',
    testnet: 'https://mempool.space/testnet/api',
  },
  blockstream: {
    mainnet: 'https://blockstream.info/api',
    testnet: 'https://blockstream.info/testnet/api',
  },
}

// todo move this file

export const DURATIONS = {
  REFRESH_EXCHANGE_RATE: 20, // 20s,
  //milliseconds
  TEN_SECONDS_MS: 10000,
  THIRTY_SECONDS_MS: 30000,
  ONE_MINUTE_MS: 60000,
  THREE_MINUTES_MS: 180000,
  FIVE_MINUTES_MS: 300000,
  ONE_HOUR_MS: 3600000,

  //seconds
  TEN_SECONDS: 10,
  THIRTY_SECONDS: 30,
  ONE_MINUTE: 60,
  THREE_MINUTES: 180,
  FIVE_MINUTES: 300,
  ONE_HOUR: 3600,
}

export const SELECTED_ALL = 'ALL'
export const REFERRAL_CODE_LEGACY = 'referralCode'
export const REFERRAL_CODE = 'ref'
